/** @param {Record<string, unknown>} sala */
export function salaTipo(sala) {
  const t = String(sala?.tipo_sala ?? 'adulto').toLowerCase();
  return t === 'infantil' ? 'infantil' : 'adulto';
}

function compareRankingRows(a, b) {
  const ta = Number(a.taxa_comparecimento ?? 0);
  const tb = Number(b.taxa_comparecimento ?? 0);
  if (tb !== ta) return tb - ta;
  const pa = Number(a.pontuacao_media_sem_oferta ?? 0);
  const pb = Number(b.pontuacao_media_sem_oferta ?? 0);
  if (pb !== pa) return pb - pa;
  const oa = Number(a.soma_oferta_periodo ?? 0);
  const ob = Number(b.soma_oferta_periodo ?? 0);
  if (ob !== oa) return ob - oa;
  return String(a.sala_id).localeCompare(String(b.sala_id));
}

/**
 * Filtra itens do ranking pelas salas do tipo e recalcula posição (1..n) pelo mesmo critério da API.
 */
export function filterRankingBySalaTipo(ranking, salas, tipo) {
  const idSet = new Set(
    (salas || []).filter((s) => salaTipo(s) === tipo).map((s) => String(s.id))
  );
  const rows = (ranking || []).filter((r) => idSet.has(String(r.sala_id)));
  const sorted = [...rows].sort(compareRankingRows);
  return sorted.map((item, idx) => ({ ...item, posicao: idx + 1 }));
}

export function rankingWorstFirst(list) {
  const copy = [...(list || [])];
  copy.sort((a, b) => (b.posicao ?? 0) - (a.posicao ?? 0));
  return copy;
}
